module.exports = __webpack_public_path__ + "static/img/source1.de90603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/zh/source1.png
// module id = tgx0
// module chunks = 1